{
  "labels": {
    "naziv": "Name",
    "naslov": "Address",
    "posta": "Postal Code",
    "kraj": "City",
    "telefon": "Phone",
    "email": "Email"
  },
  "buttons": {
    "vnesi": "Add entry"
  }
}